import { LogoGradient } from './Components/LogoGradient';
import { FULL_PATH, ICON_PATH } from './Constants/Logo.constants';
import type { LogoProps } from './Logo.types';

import styles from './Styles/Default.module.css';

export function Logo({
  fontSize = 40,
  usage = 'dark_bg',
  variant = 'full',
  ariaHidden = true,
  title,
  ariaLabel,
  role,
  dataTestId,
}: LogoProps) {
  const colorWay = usage;

  if (usage === 'gradient') {
    return (
      <LogoGradient
        fontSize={fontSize}
        ariaHidden={ariaHidden}
        title={title}
        ariaLabel={ariaLabel}
        role={role}
        dataTestId={dataTestId}
      />
    );
  }

  const isIcon = variant === 'icon';

  return (
    <svg
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      className={styles.logo}
      data-test-id={dataTestId}
      role={role}
      style={{ fontSize }}
      viewBox={isIcon ? '0 0 44 40' : '0 0 157 40'}
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      <path className={styles[colorWay]} d={isIcon ? ICON_PATH : FULL_PATH} />
    </svg>
  );
}

Logo.displayName = 'Logo';

export default Logo;
